import { WSPLUGIN_ENTRY_SYNAPSE } from '@cores/constants/envConfig';
import { bus, destroyApp, preloadApp, setupApp, startApp } from 'wujie';
// const entryUrlRaw = 'http://localhost:8081/clinical-result.html';
// const entryUrlRaw = 'http://qa-micro.zhihuiya.com/synapse_micro-workspace/clinical-result.html';
const entryUrlRaw = `${WSPLUGIN_ENTRY_SYNAPSE}/clinical-result.html`;
function addQueryParamsToUrl(url, params) {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);
    for (const [key, value] of Object.entries(params)) {
        searchParams.set(key, value);
    }
    urlObj.search = searchParams.toString();
    return urlObj.toString();
}
// 十分钟缓存
const entryUrl = addQueryParamsToUrl(entryUrlRaw, {
    noCache: parseInt(String(Date.now() / (1000 * 60 * 10))).toString(),
});
/* 版本没发布前，允许自动回退到上个版本 */
/* eslint-disable  no-var */
var getTryEntryUrl = (function () {
    function extractOrSetVersionNumber(text, newVersion) {
        const regex = /\/(\d+\.\d+\.\d+)/;
        const match = text.match(regex);
        if (match) {
            const oldVersion = match[1];
            if (newVersion) {
                const modifiedText = text.replace(regex, `/${newVersion}`);
                return modifiedText;
            }
            else {
                return oldVersion;
            }
        }
        else {
            return null;
        }
    }
    function decreaseVersionMinor(version) {
        const parts = version.split('.');
        parts[1] = parseInt(parts[1], 10) - 1;
        if (parts[1] < 0) {
            parts[1] = 0;
        }
        return parts.join('.');
    }
    async function run() {
        const v = extractOrSetVersionNumber(entryUrlRaw);
        if (!v) {
            console.log(`No valid version on microApp entry ${entryUrlRaw}. this is not a error`);
            return entryUrlRaw;
        }
        const url = addQueryParamsToUrl(entryUrlRaw, { pretest: (Date.now()).toString() });
        const useUrl = await fetch(url, { credentials: 'omit', method: 'HEAD' })
            .then(response => {
            if ([404, 403].includes(response.status)) {
                return false;
            }
            return true;
        })
            .catch(err => {
            // 凡是非404的错误都忽略
            console.error(err);
            return Promise.resolve(true);
        });
        if (useUrl) {
            return entryUrl;
        }
        else {
            // 发生了404 403，降低版本号
            const lowerVersion = decreaseVersionMinor(v);
            console.error(`
                ******************************
                * Fallback microApp entryUrl *
                * use older version: ${lowerVersion}  *
                ******************************
            `);
            return extractOrSetVersionNumber(entryUrl, lowerVersion);
        }
    }
    let promise;
    return () => {
        if (!promise) {
            promise = run();
        }
        return promise;
    };
})();
export class MicroApp {
    constructor(id) {
        this.id = id;
        this.startAppQueue = Promise.resolve();
        console.info('MicroApp: ', id, entryUrl);
        const k = `entry-url-${id}`;
        if (localStorage.getItem(k)) {
            this.entryUrl = localStorage.getItem(k);
            console.debug(k, entryUrl);
        }
        else {
            this.entryUrl = entryUrl;
        }
    }
    get baseOptions() {
        return {
            name: this.id,
            url: this.entryUrl,
        };
    }
    getEntryUrl() {
        return getTryEntryUrl()
            .then(newUrl => {
            this.entryUrl = newUrl;
            return newUrl;
        })
            .catch(err => {
            console.error(err);
            this.entryUrl = entryUrl;
            return entryUrl;
        });
    }
    preload() {
        this.getEntryUrl()
            .then(() => {
            setupApp(this.baseOptions);
            preloadApp(this.baseOptions);
        });
    }
    start(mountNode, props) {
        // @ts-ignore
        window.seqMicroAppProps = props;
        this.startAppQueue = this.startAppQueue.then(() => {
            return this.getEntryUrl()
                .then(() => startApp({
                ...this.baseOptions,
                sync: true,
                alive: false,
                el: mountNode,
                props,
                plugins: [
                    {
                        cssBeforeLoaders: [
                            {
                                content: `
                                            body > div.h-full.w-full.bg-white {
                                                display: flex;
                                            }
                                            body > div.h-full.w-full.bg-white > div:nth-child(1) {
                                                position: initial !important;
                                                flex-shrink: 0 !important;
                                            }
                                        `,
                            },
                        ],
                    },
                ],
            }));
        });
        return this.startAppQueue;
    }
    triggerQueryUpdate() {
        bus.$emit('route-change');
    }
    triggerAsideExpandUpdate() {
        bus.$emit('aside-expand');
    }
    // keep alive 不一定需要destroy
    destroy() {
        destroyApp(this.id);
    }
}
